
export const libraries = {
    "STRING": [
        {
            name: 'NO-ACTION',
            fields: {}
        },
        {
            name: 'APPEND',
            fields: {
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'ASSIGN',
            fields: {
                assignSource: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'CAPITALIZE',
            fields: {
                sourceString: { value: '##-##', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'LOWERCASE',
            fields: {
                sourceString: { value: '##-##', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'PREPEND',
            fields: {
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'REPLACE',
            fields: {
                sourceString: { value: '##-##', defaultValue: true },
                set: { value: '##-##', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'SUBSTRING',
            fields: {
                sourceString: { value: '##-##', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'TRIM',
            fields: {
                sourceString: { value: '##-##', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'UPPERCASE',
            fields: {
                sourceString: { value: '##-##', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        }
    ],
    "NUMBER": [
        {
            name: 'NO-ACTION',
            fields: {}
        },
        {
            name: 'ASSIGN',
            fields: {
                assignSource: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'RANDOM',
            fields: {
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        }
    ],
    "DATE": [
        {
            name: 'NO-ACTION',
            fields: {}
        },
        {
            name: 'MODIFY-DATE',
            fields: {
                date: { value: '-', type: 'VARIABLEPICKER', defaultValue: true },
                output: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
    ],
    "ARRAY": [
        {
            name: 'NO-ACTION',
            fields: {}
        },
        {
            name: 'ADD',
            fields: {
                set: { value: '##-##', defaultValue: true }
            }
        },
        {
            name: 'ASSIGN',
            fields: {
                set: { value: '##-##', defaultValue: true }
            }
        },
        {
            name: 'REMOVE',
            fields: {
                variable: { value: '##-##', defaultValue: true }
            }
        }
    ],
    "OBJECT": [
        {
            name: 'NO-ACTION',
            fields: {}
        },
        {
            name: 'APPEND',
            fields: {
                set: { value: '##-##', defaultValue: true }
            }
        },
        {
            name: 'ASSIGN',
            fields: {
                set: { value: '##-##', defaultValue: true }
            }
        },
        {
            name: 'REMOVE-KEYS',
            fields: {
                source: { value: '##-##', defaultValue: true }
            }
        }
    ],
    "DATA-TABLE": [
        {
            name: 'NO-ACTION',
            fields: {}
        },
        {
            name: 'ADD-ROW-NUMBERS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'ASSIGN',
            fields: {
                assignSource: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'FILL-BLANK-CELLS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'FILTER-ROWS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'FIND-&-CLEAN',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'FIND-&-REPLACE',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'FIND-MAX-BY-GROUP',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'FIND-MIN-BY-GROUP',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'INSERT-ROW',
            fields: {
                assignSource: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'LIMIT-ROWS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'MATH-BY-GROUP',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'MERGE-COLUMNS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'MERGE-DUPLICATE-ROWS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true },
                set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'REMOVE-DUPLICATE-ROWS',
            fields: {
                assignSource: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'REPLACE-WITH-REGEX',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'ROTATE-TABLE',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'SORT-ROWS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'SPLIT-COLUMNS',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'TEXT-FORMATTING',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        },
        {
            name: 'UPDATE-CELL',
            fields: {
                sourceData: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
            }
        }
    ],
    "BOOLEAN": [
        {
            name: 'NO-ACTION',
            fields: {}
        }
    ]
}